import type { BillingCashFlowPeak } from '@practium/features/api';

export const formatBRL = (value: number, withCents = true) =>
	value.toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: withCents ? 2 : 0,
		maximumFractionDigits: withCents ? 2 : 0,
	});

export const formatCompactValue = (value: number) =>
	value >= 1000
		? `${(value / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}k`
		: value.toLocaleString('pt-BR', { maximumFractionDigits: 0 });

export const buildCashFlowSummary = (
	peakInflow: BillingCashFlowPeak | null,
	peakOutflow: BillingCashFlowPeak | null,
) => {
	const inflowText = peakInflow
		? `Maior entrada no dia ${peakInflow.day}, com ${formatBRL(peakInflow.value, false)}.`
		: 'Nenhuma entrada registrada no período.';
	const outflowText = peakOutflow
		? `Maior saída no dia ${peakOutflow.day}, com ${formatBRL(peakOutflow.value, false)}.`
		: 'Nenhuma saída registrada no período.';

	return `${inflowText} ${outflowText}`;
};
